import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'
import { toMoney } from '../../../../common/helpers/format'

const formatSellDetail = (sellDetails) => {
    let buffer = []

    sellDetails.forEach(element => {
        if (element.Service) {
            buffer.push(<span>{element.quantity} x {element.Service.name} <b>(s/{toMoney(element.total_net)})</b>, </span>);
        }
        else if (element.Offer) {
            element.Offer.Offer_services.forEach(offer_service => {
                buffer.push(<span>{element.quantity} x {`(Oferta)(${offer_service.Service.name})`} <b>(s/{toMoney(element.total_net)})</b>, </span>);
            })
        }
        else {
            buffer.push(<span>{element.quantity} x Sin Servicio,</span>);
        }
    });
    return buffer;
}

export const columnsServiceDetailsXS = [
    {
        dataField: 'xs',
        text: 'Balance por Servicio Detallado',
        formatter: (cell, row) => {
            const sellDetail = formatSellDetail(row.sellDetails)
            return (
                <div>
                    <TableRowField label='Concepto:' value={sellDetail} />
                    <TableRowField label='Cliente:' value={row.customer} />
                    <TableRowField label='Empleados:' value={row.employee} />
                    <TableRowField label='Forma de Pago:' value={row.paymentMethod} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
]
export const columnsServiceDetailsSM = [
    {
        dataField: 'xs',
        text: 'Balance por Servicio Detallado',
        formatter: (cell, row) => {
            const sellDetail = formatSellDetail(row.sellDetails)
            return (
                <div>
                    <TableRowField label='Concepto:' value={sellDetail} />
                    <TableRowField label='Cliente:' value={row.customer} />
                    <TableRowField label='Empleados:' value={row.employee} />
                </div>
            )
        }
    },
    {
        dataField: 'payment',
        text: 'Forma de Pago',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Forma de Pago:' value={row.paymentMethod} />
                </div>
            )
        }
    },
    {
        dataField: 'total_net_sell_detail',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
];
export const columnsServiceDetailsMD = [
    {
        dataField: 'service',
        text: 'Concepto',
        formatter: (cell, row) => {
            const sellDetail = formatSellDetail(row.sellDetails)
            return (
                <div>
                    <TableRowField label='' value={sellDetail} />
                </div>
            )
        }
    },
    {
        dataField: 'client',
        text: 'Cliente',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.customer} />
                </div>
            )
        }
    },
    {
        dataField: 'employee',
        text: 'Empleados',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.employee} />
                </div>
            )
        }
    },
    {
        dataField: 'payment',
        text: 'Forma de Pago',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.paymentMethod} />
                </div>
            )
        }
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
];

export const columnsServiceNamesXS = [
    {
        dataField: 'xs',
        text: 'Ventas por Servicio',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Servicio:' value={row.name} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
]
export const columnsServiceNamesSM = [
    {
        dataField: 'xs',
        text: 'Ventas por Servicio',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Servicio:' value={row.name} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
];
export const columnsServiceNamesMD = [
    {
        dataField: 'service',
        text: 'Servicio',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.name} />
                </div>
            )
        }
    },
    {
        dataField: 'quantity',
        text: 'Cantidad',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.quantity} />
                </div>
            )
        }
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
];


// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ServiceBalance/_columns.js